export default{
    'prefix': "Prefixo",
    'station_type': 'Tipo de Posto',
    'city': 'Município',
    'ugrhi': 'Ugrhi',
    'station_owner': 'Proprietário',
    'transmission_status': 'Status da Transmissão'
}